import script from "./ExpendeduriaDrawerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpendeduriaDrawerComponent.vue?vue&type=script&setup=true&lang=js"

import "./ExpendeduriaDrawerComponent.vue?vue&type=style&index=0&id=7f857fd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f857fd9"]])

export default __exports__